"use strict";

var util = require("util");

exports.format = util.format;
exports.inherits = util.inherits;

/**
 * Regular Expression that matches Swagger path params.
 */
exports.swaggerParamRegExp = /\{([^/}]+)}/g;



//////////////////
// WEBPACK FOOTER
// ./node_modules/swagger-parser/lib/util.js
// module id = A4kD
// module chunks = 11